module.exports = __webpack_public_path__ + "img/c10.9a5cf350.png";